"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_NODE_RELATIONS = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.GET_NODE_RELATIONS = (0, gql_1.gql)(`
  query NodeRelations(
    $productTreeNodeId: ID!, 
    $sort: [ProductTreeNodeRelativeOrderBy!]!
  ) {
    productTreeNode(id: $productTreeNodeId) {
      id
      title
      ancestors(sort: $sort) {
        totalCount
        edges {
          node {
            ancestor {
              id
              title
            }
          }
        }
      }
      descendants {
        totalCount
      }
    }
  }
`);
